import { Box } from '@mui/material';

export const PulsatingCircle = () => (
  <Box
    sx={(theme) => ({
      alignItems: 'center',
      display: 'flex',
      height: theme.typography.body2.lineHeight,
      justifyContent: 'center',
      width: '18px',
      '&::after': {
        animation:
          '700ms cubic-bezier(0.420, 0.000, 0.580, 1.000) 0s infinite alternate pulse-circle',
        '@keyframes pulse-circle': {
          '0%': {
            transform: 'scale(1)',
          },
          '100%': {
            transform: 'scale(1.4)',
          },
        },
        borderRadius: '50%',
        backgroundColor: 'black',
        height: '8px',
        width: '8px',
        content: '""',
        display: 'block',
      },
    })}
  />
);
